import Dialog from './Index.vue'
import { getVmSingleton } from '@/utils/utils'

const dialogCmp = {
  install (Vue) {
    const vm = getVmSingleton(Dialog)()
    const obj = (data, cb) => {
      vm.open(data, cb)
    }
    window.unbindClose = vm.close
    Vue.prototype.$dialog = obj
  }
}

export default dialogCmp
